//@author: mandy

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { S25WorkflowComponent } from "./s25.workflow.component";
import { S25ToggleButtonModule } from "../../s25-toggle-button/s25.toggle.button.module";

import { S25IconComponent } from "../../s25-icon/s25.icon.component";

@NgModule({
    declarations: [S25WorkflowComponent],
    imports: [CommonModule, FormsModule, S25ToggleButtonModule, S25IconComponent],
    providers: [S25WorkflowComponent],
    exports: [S25WorkflowComponent],
})
export class S25WorkflowModule {
    constructor() {}
}
